import dateField from "../../common/date-field";
import decimalField from "../../common/decimal-field.vue";
import { hasValue } from "../../../utils/functions.js";

import DataTable from "primevue/datatable";
import MultiSelect from 'primevue/multiselect';
import Column from "primevue/column";
import TableList from "../../sub-components/Generic/TableList/TableList.vue";

const methods = {
  SituacaoAtual(data) {
    if (data.Merchant.Id == 0) {
      return "-";
    } else if (data.Merchant.IsRemoved == 0 && data.Merchant.IsBlocked == 0) {
      return "Ativo";
    } else if (data.Merchant.IsRemoved == 1 && data.Merchant.IsBlocked == 0) {
      return "Removido";
    } else if (data.Merchant.IsRemoved == 1 && data.Merchant.IsBlocked == 1) {
      return "Removido e na Blocklist";
    } else if (data.Merchant.IsRemoved == 0 && data.Merchant.IsBlocked == 1) {
      return "Ativo mas na Blocklist";
    } else {
      return "-";
    }
  },
  BackgroundCheckStatus(data) {
    if (data.Status == 0) {
      return "Aguardando Onboard";
    } else if (data.Status == 1) {
      return "Aprovado";
    } else if (data.Status == 2) {
      return "Reprovado";
    } else {
      return "-";
    }
  }
};

export default {
  name: "merchantsPreview",
  components: {
    dateField,
    decimalField,
    TableList,
    DataTable,
    MultiSelect,
    Column
  },
  data() {
    return {
      cities: [],
      countries: [],
      states: [],
      listStatus: [],
      merchantsPreview: [],
      partners: [],
      correlationList: [],
      expandedRows: [],
      backgroundCheckList: [],
      status: [
        { Id: 0, Name: "Aguardando Onboard" },
        { Id: 1, Name: "Aprovado" },
        { Id: 2, Name: "Rejeitado" }
      ],
      mCurrentStep: "Empresa",
      mCurrentStepConfirm: 0,
      countFilter: 0,

      isSearchZipCode: false,
      approve: false,
      validatedCompanyStep: false,
      validatedResponsibleStep: false,
      validatedTaxForm: false,
      validatedTechStep: false,
      validatedChangeEmail: false,
      validatedMerchant: false,
      validatedUpdatePartner: false,
      validatedMerchantContract: false,
      validatedReasonStep: false,
      validatedBlockListAdd: false,
      loading: false,
      loadingInfo: false,
      loadingStatus: false,
      loadingRecuse: false,
      loadingCorrelation: false,
      loadingValidateMerchant: false,
      isView: false,
      UserInternal: undefined,
      DateTimeNow: null,

      validatedRefuseReason: false,
      refusedReasons: [],

      filter: this.DefaultFilter(),
      infoMerchantPreview: this.DefaultInfoMerchantPreview(),
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      selectMerchantPreview: null,
      correlationPagination: null,
      correlationSelected: null,

      mStepsIsView: ["Empresa", "Responsável", "Contato Técnico", "Informações", "Segurança"],
      mStepsIsNotView: ["Empresa", "Responsável", "Contato Técnico", "Informações",],
      mStepsRecuse: ["reason", "confirm"],
      correlationOptions: ["CPF/CNPJ","IP", "Fingerprint", "IP + Fingerprint"],
      correlationHeader: [
        { field: "Merchant.Id", label: "Id Merchant", default: "-" },
        { field: "Merchant.IdMerchantRoot", label: "Id MerchantRoot", default: "-" },
        { field: "Merchant.Identity", label: "Inscrição", type: "identity", classField: "break-word" },
        { field: "CreatedDate", label: "Data de Cadastro", type: "dateTime" },
        { field: "MerchantPreviewStatus.Name", label: "Situação Pré-Cadastro" },
        { field: methods.SituacaoAtual, label: "Situação Atual" }
      ],
      MerchantPreviewCorrelationHeader: [
        { field: "Merchant.Id", label: "Id", default: "-" },
        { field: "Merchant.Name", label: "Cliente",default: "-" },
        { field: "Merchant.IdMerchantRoot", label: "Id MerchantRoot", default: "-" },
        { field: "MerchantRoot.Name", label: "Nome do Marketplace", default: "-" },
      ],
      singleCorrelationHeader: [
        { field: "Id", label: "Id Merchant", default: "-" },
        { field: "IdMerchantRoot", label: "Id MerchantRoot", default: "-" },
        { field: "Identity", label: "Inscrição", type: "identity", classField: "break-word" },
        { field: "CreatedDate", label: "Data de Cadastro", type: "dateTime" },
        { field: "MerchantPreviewStatus.Name", label: "Situação Pré-Cadastro" },
        { field: methods.SituacaoAtual, label: "Situação Atual" }
      ],
      listBackgroundCheckStatus: [
        { Id: 0, Name: "Aguardando Onboard" },
        { Id: 1, Name: "Aprovado" },
        { Id: 2, Name: "Rejeitado" }
      ],
      statusIdentitiesHeader: [
        { field: "Type", label: "Tipo" },
        { field: "Identity", label: "Documento", type: "identity" },
        { field: methods.BackgroundCheckStatus, label: "Status" },
        { field: "StatusDate", label: "Ultima Atualização", type: "dateTime" }
      ]
    };
  },
  computed: {
    Country() {
      return this.infoMerchantPreview.Address.Country.Name;
    },
    State() {
      return this.infoMerchantPreview.Address.State.Initials;
    },
    StepsMerchantPreview(){
      return this.isView ? this.mStepsIsView : this.mStepsIsNotView;
    },
    CurrentStepIndex(){
      return this.GetStepIndex(this.mCurrentStep);
    },
    StepSize(){
      return this.StepsMerchantPreview.length;
    },
    MerchantPreviewModalName(){
      const name = this.infoMerchantPreview.Name ? this.infoMerchantPreview.Name : "";
      const id = this.infoMerchantPreview.Id ? `[${this.infoMerchantPreview.Id}]` : "";
      return this.isView ? `Detalhes do cadastro ${name} ${id}` : "Realizar cadastro";
    }
  },
  watch: {
    correlationSelected(newValue) {
      if (newValue != null) {
        this.ListCorrelation();
      }
    },
    "pagination.PageNumber"() {
      this.ListMerchantPreview();
    },
    "pagination.RowsPerPage"() {
      this.ListMerchantPreview();
    },
    State(selected, old) {
      // Update City list when the State (of Country) is changed.
      if (selected != null) {
        this.$store.dispatch("ListCity", { stateInitials: selected }).then(response => {
          this.cities = response;
        });
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.infoMerchantPreview.Address.City.Name = null;
        }
      } else {
        this.cities = [];
        this.infoMerchantPreview.Address.City.Name = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    },
    Country(selected, old) {
      // Update State list when the Country is changed.
      if (selected != null) {
        this.ListState(selected);
        if (selected != old && old != undefined && !this.isSearchZipCode) {
          this.infoMerchantPreview.Address.State.Initials = null;
        }
      } else {
        this.states = [];
        this.infoMerchantPreview.Address.State.Initials = null;
      }
      if (this.isSearchZipCode) this.isSearchZipCode = false;
    }
  },
  methods: {
    //#region Filter
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListMerchantPreview();
    },
    ResetFilter() {
      this.filter = this.DefaultFilter();
      this.ListMerchantPreview();
    },
    ListMerchantPreview() {
      this.loading = true;
      
      this.countFilter = 0;

if (hasValue(this.filter.Id)) this.countFilter++;
if (hasValue(this.filter.Name)) this.countFilter++;
if (hasValue(this.filter.Identity)) this.countFilter++;
if (hasValue(this.filter.CodeMerchantPreviewStatus)) this.countFilter++;

// Verifica se BackgroundCheckList está nulo ou vazio
if (!hasValue(this.filter.BackgroundCheckList) || this.filter.BackgroundCheckList.length === 0) {
    this.filter.BackgroundCheckList = [ 
      { Id: 1, Name: "Aprovado" }, 
      { Id: 2, Name: "Rejeitado" }  ]; // Preenche com os valores 1 e 2
      this.countFilter++;
} else {
    this.countFilter++; // Incrementa o contador apenas se a lista não estiver vazia ou nula
}

if (hasValue(this.filter.InitialDate)) this.countFilter++;
if (hasValue(this.filter.FinalDate)) this.countFilter++;
if (hasValue(this.filter.ExcludeBackgroundCheck)) this.countFilter++;

     var a = this.filter.BackgroundCheckList.map(x=>x.Id).join(',')
      
      let data = {
        ...this.pagination,
        "Object.Id": this.filter.Id,
        "Object.Identity": this.filter.Identity,
        "Object.Name": this.filter.Name,
        "Object.MerchantPreviewStatus.Code": this.filter.CodeMerchantPreviewStatus,
        "Object.BackgroundCheckList": a,
        InitialDate: this.filter.InitialDate,
        EndDate: this.filter.FinalDate,
        ExcludeBackgroundCheck: this.filter.ExcludeBackgroundCheck
      };

      console.log(data)
      this.$store
        .dispatch("ListMerchantPreview", { params: data })
        .then(response => {
          this.merchantsPreview = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro carregar os clientes pré-cadastrados.", error);
        })
        .finally(() => (this.loading = false));
    },
    //#endregion Filter

    //#region Modal UpdateStatus
    OpenModalRecuse(pMerchantPreview) {
      this.merchantPreview = pMerchantPreview;
      delete this.merchantPreview.ReasonInternal;

      this.validatedReasonStep = false;
      this.mCurrentStepConfirm = 0;

      this.$bvModal.show("mConfirm");
    },
    HideModalConfirm() {
      this.$bvModal.hide("mConfirm");
    },
    ProcessNextStepRecuse(nextStep = null) {
      this.validatedReasonStep = true;
      this.CheckValidityRecuse("ReasonStep", nextStep);
    },
    NextStepRecuse() {
      if (this.mCurrentStepConfirm < 1) {
        this.mCurrentStepConfirm += 1;
      }
    },
    BackStepRecuse() {
      if (this.mCurrentStepConfirm >= 1) {
        this.mCurrentStepConfirm -= 1;
      }
    },
    CheckValidateBlocklistAdd() {
      this.$refs.validatedBlockListAdd.validate().then(isValid => {
        if (isValid) {
          this.validatedBlockListAdd = false;
          let BlockList = {
            Name: this.infoMerchantPreview.Name,
            Identity: this.infoMerchantPreview.Identity,
            Description: this.infoMerchantPreview.Description
          }
           
          this.$store
          .dispatch("AdicionarBlocklist", BlockList)
          .then(() => {
            this.$makeToast(
              "Cadastrado corretamente na Blocklist.",
              "success",
              "Registro cadastrado"
            );

          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao adicionar na Blocklist",
              error
            );
          })
          .finally(() => {
            this.$bvModal.hide("ConfirmAction");
            this.ResetFilter();
          });
        } else {
          this.validatedBlockListAdd = true;
        }
      });
    },

    CheckValidateUnblocklistDelete() {
      this.$refs.validatedUnblockedBlockListDelete.validate().then(isValid => {
        if (isValid) {
          this.validatedUnblockedBlockListDelete = false;
          let UnBlockList = {
            Identity: this.infoMerchantPreview.Identity,
          }
           
          this.$store
          .dispatch("DeletarBlockListMerchantPreview", UnBlockList)
          .then(() => {
            this.$makeToast(
              "Registro retirado da Blocklist",
              "success",
              "Registro excluido"
            );

          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao excluir da Blocklist",
              error
            );
          })
          .finally(() => {
            this.$bvModal.hide("ConfirmActionUnblocked");
            this.ResetFilter();
          });
        } else {
          this.validatedUnblockedBlockListDelete = true;
        }
      });
    },

    CheckValidityRecuse(step, nextStep) {
      if (step == "ReasonStep") {
        this.$refs.ReasonStep.validate().then(isValid => {
          if (!isValid) {
            this.validatedReasonStep = true;
          } else {
            if (nextStep == null) {
              this.NextStepRecuse();
            } else {
              this.mCurrentStepConfirm = nextStep;
            }
            this.validatedReasonStep = false;
          }
        });
      }
    },
    ConfirmUpdateStatus(e, approve, isReprovedBefore, merchantPreview) {
      e.preventDefault();
      this.approve = approve;

      this.$makeMsgBox(
        `Você tem certeza que deseja ${approve ? "aceitar" : "recusar"} o cadastro referente ao ${merchantPreview.Name}?`,
        "Confirmar",
        approve ? (isReprovedBefore ? this.OpenModalRecuse : this.UpdateStatus) : this.OpenModalRecuse,
        merchantPreview,
        approve
      );
    },
    ConfirmRefuseMerchantPreview(idMerchantPreview) {
      this.loadingInfo = true;
      this.infoMerchantPreview.validatedRefuseReason = false;
      this.$bvModal.show("mFormRefuseMerchant");

      const time = new Date().toLocaleString().split(",")[1];
      const date = new Date();
      const d = String(date.getDate()).padStart(2, '0');
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const y = date.getFullYear();

      this.DateTimeNow = `${d}/${m}/${y} ${time}`;

      this.$store
        .dispatch("GetMerchantPreview", { id: idMerchantPreview })
        .then(response => {
          this.infoMerchantPreview = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter as informações do cadastro", error);
        })
        .finally(() => {
          this.loadingInfo = false;
        });
    },
    RefuseMerchantPreview() {
      if (this.infoMerchantPreview.RefuseReason == undefined) {
        this.validatedRefuseReason = true;
        return;
      }

      let merchantPreview = {
        Id: this.infoMerchantPreview.Id,
        MerchantPreviewStatus: {
          Code: "2"
        },
        Address: this.infoMerchantPreview.Address,
        ResponsibleName: this.infoMerchantPreview.ResponsibleName,
        ResponsibleIdentity: this.infoMerchantPreview.ResponsibleIdentity,
        ResponsiblePhone: this.infoMerchantPreview.ResponsiblePhone,
        Email: this.infoMerchantPreview.Email,
        ReasonInternal: this.infoMerchantPreview.RefuseObservation,
        RefusedReason: {
          Id: this.infoMerchantPreview.RefuseReason
        }
      };
      this.$store
        .dispatch("UpdateMerchantPreviewStatus", merchantPreview)
        .then(() => {
          this.$makeToast("Sua solicitação foi processada com sucesso", "success", "Pré-cadastro do Cliente");
          setTimeout(() => {
            this.ListMerchantPreview();
          }, 100);
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao processar sua solicitação", error);
        })
        .finally(() => {
          this.loading = false;
          this.$bvModal.hide("mFormRefuseMerchant");
        });
    },
    CloseRefuseModal() {
      this.validatedRefuseReason = false;
      this.infoMerchantPreview = this.DefaultInfoMerchantPreview();
      this.$bvModal.hide("mFormRefuseMerchant");
    },
    MerchantPreviewListCorrelation(Identity){
      let payload = {};
      
      payload["Object.Identity"] = Identity;
      
      this.$store
      .dispatch("ListMerchantPreviewCorrelation", payload)
      .then(response => {
        this.correlationList = response.Objects;
        this.correlationPagination.TotalItems = response.TotalItems;
      })
      .catch(error => this.$makeToast(undefined, "Erro ao obter as informações do cadastro", error))
      .finally(() => (this.loadingCorrelation = false));
    },

     ConfirmUpdateBlockedAndUnblocked(merchantPreview){
      this.validatedBlockListAdd = false;
      this.validatedUnblockedBlockListDelete = false;

      
      this.GetMerchantPreview(merchantPreview.Id);
      this.MerchantPreviewListCorrelation(merchantPreview.Identity)

      if(merchantPreview.IsBlocked == false){
        this.$bvModal.show("ConfirmAction");
      }else{
        this.$bvModal.show("ConfirmActionUnblocked");
      }
    },
    AddBlockList(){
      this.CheckValidateBlocklistAdd();
    },
    ConfirmUpdateUnBlocked(){ 
      this.CheckValidateUnblocklistDelete();
  },
    UpdateStatus(merchant, approve) {
      let code = "";

      this.HideModalConfirm();
      this.loading = true;
      var vApprove = approve == undefined ? this.approve : approve;

      if (vApprove) {
        code = "1";
      } else {
        code = "2";
      }

      let merchantPreview = {
        Id: merchant.Id,
        MerchantPreviewStatus: {
          Code: code
        },
        Email: merchant.Email,
        TechEmail: merchant.TechEmail,
        ReasonInternal: merchant.ReasonInternal
      };
      this.$store
        .dispatch("UpdateMerchantPreviewStatus", merchantPreview)
        .then(() => {
          this.$makeToast("Sua solicitação foi processada com sucesso", "success", "Pré-cadastro do Cliente");
          setTimeout(() => {
            this.ListMerchantPreview();
          }, 100);
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao processar sua solicitação", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //#endregion Modal UpdateStatus

    //#region Modal Validation
    OpenValidateMerchant() {
      this.loadingValidateMerchant = false;
      this.validatedCompanyStep = false;
      this.validatedMerchant = false;
      this.infoValidateMerchant = {
        Email: null,
        ResponsibleIdentity: null,
        Identity: null
      };
      this.$bvModal.show("mValidateMerchant");
    },
    ValidateMerchant() {
      this.validatedMerchant = true;
      this.$refs.ValidateMerchantForm.validate().then(isValid => {
        if (isValid) {
          this.validatedMerchant = false;
          this.loadingValidateMerchant = true;
          this.$store
            .dispatch("ValidateMerchant", this.infoValidateMerchant)
            .then(response => {
              if (response.HasErrorValidate) {
                this.ConfirmHasErrorValidate(response);
              } else {
                this.PreSetMerchantPreview(response);
              }
            })
            .catch(error => {
              this.$makeToast(undefined, "danger", "Erro ao validar o cliente", error);
            })
            .finally(() => {
              this.loadingValidateMerchant = false;
            });
        }
      });
    },
    PreSetMerchantPreview(response) {
      const preSetData = {
        Name: response.Name,
        IsMEI: response.IsMei,
        Identity: response.Identity,
        ResponsibleName: response.ResponsibleName,
        ResponsibleIdentity: response.ResponsibleIdentity,
        Email: response.Email
      };

      this.$bvModal.hide("mValidateMerchant");

      this.OpenMerchantPreview(0, false, preSetData);
    },
    //#endregion Modal Validation

    //#region Modal MerchantPreview
    OpenMerchantPreview(idMerchantPreview, isView, preSetInfoMerchantPreview = null, isEdit = false) { 
      this.mCurrentStep = 'Empresa';
      this.isView = isView;   
      this.isEdit = isEdit;
      if(!this.isView && preSetInfoMerchantPreview != null)
        this.infoMerchantPreview = {
          ...this.DefaultInfoMerchantPreview(),
          ...preSetInfoMerchantPreview
        };
      else
        this.infoMerchantPreview = this.DefaultInfoMerchantPreview();

      this.validatedMerchant = false;
      this.validatedCompanyStep = false;
      this.validatedResponsibleStep = false;
      this.validatedTechStep = false;

      // View
      if (this.isView){ 
        this.GetMerchantPreview(idMerchantPreview);
      }
      if (this.isView == false && this.isEdit == true){
        this.GetMerchantPreview(idMerchantPreview);
        this.$bvModal.show("mFormEditarMerchantPreview");
      } else {
        this.$bvModal.show("mFormMerchantPreview"); 
      } 
    },
    async JumpToStep(selectedStep){
      const isBackStep = this.CurrentStepIndex >= this.GetStepIndex(selectedStep);
      if(!this.isView && !isBackStep && !await this.ValidateStep()){
        return;
      }
      if(this.mCurrentStep != selectedStep)
        this.mCurrentStep = selectedStep;
    },
    async NextStep() {
      if(!this.isView && !await this.ValidateStep()){
        return;
      }
      if (this.CurrentStepIndex < (this.StepSize-1)) {
        this.mCurrentStep = this.StepsMerchantPreview[this.CurrentStepIndex+1];
      }
    },
    BackStep() {
      if (this.CurrentStepIndex > 0) {
        this.mCurrentStep = this.StepsMerchantPreview[this.CurrentStepIndex-1];
      }
    },
    async ValidateStep(){
      let isValid = false;
      switch (this.mCurrentStep) {
        case "Empresa":
          this.validatedCompanyStep = true;
          isValid = await this.CheckValidityStepCompany();
          break;
        case "Responsável":
          this.validatedResponsibleStep = true;
          isValid = await this.CheckValidityStepResponsible();
          break;
        //case "Contato Técnico":
        //  this.validatedTechStep = true;
        //  isValid = await this.CheckValidityStepContactTechStep();
        //  break;
        default:
          isValid = true;
          break;
      }
      return isValid;
    },
     GetMerchantPreview(id) {
      this.loadingInfo = true;
      this.AllSettled([
        this.$store
          .dispatch("GetMerchantPreview", { id: id })
          .then(response => {
            this.infoMerchantPreview = response;
            delete this.infoMerchantPreview.Address.City.CodeIBGE;
            delete this.infoMerchantPreview.Address.City.Id;
            this.hasPartner = this.infoMerchantPreview.Partner.Id ? true : false;
          })
          .catch(error => {
            this.$makeToast(undefined, "danger", "Erro ao obter as informações do cadastro", error);
          }),

        this.$store
          .dispatch("ListBackgroundCheck", { "Object.IdMerchantPreview": id })
          .then(response => {
            this.backgroundCheckList = response.Objects;
          })
          .catch(error => {
            this.$makeToast(undefined, "danger", "Erro ao carregar a checagem de background", error);
          })
      ]).finally(() => {
        this.loadingInfo = false;
      });
    },

    //Edição de merchantPreview
    EditarMerchantPreview(id) {
    
      this.GetMerchantPreview(id);
      this.loadingInfo = true;
      this.$store
        .dispatch("UpdateMerchantPreviewResposible",this.infoMerchantPreview)
        .then(() => {
          this.$makeToast("Sua solicitação foi processada com sucesso", "success", "Atualização do Cliente");          
        })
        .catch(error => {
          this.$makeToast(undefined, "Erro", "Erro ao Editar as informações do Merchant", error);
        })
        this.$bvModal.hide("mFormEditarMerchantPreview");
        this.$bvModal.hide("mFormMerchantPreview");  
        this.loadingInfo = false;
    },
    HideModal() {
      this.$bvModal.hide("mFormEditarMerchantPreview");
      this.$bvModal.hide("mFormMerchantPreview");
    },
    AddMerchantPreview() {
      this.loadingInfo = true;
      this.$store
        .dispatch("AddMerchantPreview", this.infoMerchantPreview)
        .then(() => {
          this.$bvModal.hide("mFormMerchantPreview");
          this.ListMerchantPreview();
          this.$makeToast("Foi inicializado o onboarding do cliente!", "success", "Onboarding de Clientes");
        })
        .catch(error => {
          this.$makeToast("Não foi possível iniciar o onboarding do Cliente.", "danger", "Onboarding de Clientes", error);
        })
        .finally(() => {
          this.loadingInfo = false;
        });
    },
    async CheckValidityStepCompany() {
      let isValid = false;
      await this.$refs.CompanyStep.validate().then(valid => isValid = valid);
      return isValid;
    },
    async CheckValidityStepResponsible() {
      const allValid = [];
      const validators = [
        this.$refs.ResponsibleNameStep.validate().then(fieldName => allValid.push(fieldName.valid)),
        this.$refs.ResponsibleCpfStep.validate().then(fieldCpf => allValid.push(fieldCpf.valid)),
        this.$refs.ResponsibleEmailStep.validate().then(fieldEmail => allValid.push(fieldEmail.valid)),
        this.$refs.ResponsibleStep.validate().then(validStep => allValid.push(validStep))
      ];
      await this.AllSettled(validators);
      return allValid.every(item => item == true);
    },
    async CheckValidityStepContactTechStep() {
      const isPristine = this.$refs.TechStep.flags.pristine;
      let isValid = false;
      await this.$refs.TechStep.validate().then(valid => isValid == valid);
      return isPristine && isValid;
    },
    //#endregion Modal MerchantPreview
    
    //#region Modal Correlation
    OpenCorrelation(selectMerchantPreview) {
      this.selectMerchantPreview = null;
      this.correlationPagination = {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      };
      this.correlationSelected = null;
      this.correlationList = [];
      this.loadingInfo = true;
      this.$store
        .dispatch("GetMerchantPreview", { id: selectMerchantPreview.Id })
        .then(response => (this.selectMerchantPreview = response))
        .catch(error => this.$makeToast(undefined, "Erro ao obter as informações do cadastro", error))
        .finally(() => (this.loadingInfo = false));
      this.$bvModal.show("mCorrelation");
    },
    ListCorrelation() {
      this.loadingCorrelation = true;
      const payload = { ...this.correlationPagination };

      if (this.correlationSelected.includes("CPF/CNPJ")) {
        payload["Object.Identity"] = this.selectMerchantPreview.Identity; 
      }

      if (this.correlationSelected.includes("IP")) {
        payload["Object.IpAddress"] = this.selectMerchantPreview.IpAddress;
      }

      if (this.correlationSelected.includes("Fingerprint")) {
        payload["Object.Fingerprint"] = this.selectMerchantPreview.Fingerprint;
      }

      this.$store
        .dispatch("ListMerchantPreviewCorrelation", payload)
        .then(response => {
          this.correlationList = response.Objects;
          this.correlationPagination.TotalItems = response.TotalItems;
        })
        .catch(error => this.$makeToast(undefined, "Erro ao obter as informações do cadastro", error))
        .finally(() => (this.loadingCorrelation = false));
    },
    //#endregion Modal Correlation

    //#region Aux
    GetStepIndex(step){
      return this.StepsMerchantPreview.findIndex(item => item == step);
    },
    AllSettled(promises) {
      let wrappedPromises = promises.map(p =>
        Promise.resolve(p).then(
          val => ({ status: "fulfilled", value: val }),
          err => ({ status: "rejected", reason: err })
        )
      );
      return Promise.all(wrappedPromises);
    },
    GetClass(id) {
      return id == 0 ? "fas fa-minus" : "";
    },
    BackgroundCheckStatusSum(StatusIdentities) {
      if (!hasValue(StatusIdentities) || StatusIdentities.length < 2) {
        return "QSA não identificado";
      }
      if (StatusIdentities.some(elem => elem.Status == 2)) {
        return "Reprovado";
      }
      if (StatusIdentities.every(elem => elem.Status == 1)) {
        return "Aprovado";
      }
      return "Aguardando Onboard";
    },
    //#endregion Aux
    
    //#region Non-Specific Lists
    ListPartner() {
      let data = { OrderByColumn: "Name" };
      this.$store
        .dispatch("ListPartner", { params: data })
        .then(response => {
          this.partners = response.Objects;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de parceiros", error);
        });
    },
    ListCountry() {
      this.$store
        .dispatch("ListCountry")
        .then(response => {
          this.countries = response;
        })
        .catch(error => this.$makeToast(undefined, "danger", "Erro carregar a lista de países", error));
    },
    ListState(nameCountry) {
      if (nameCountry != null) {
        let CountryItem = this.countries.find(elem => {
          return elem.Name.toUpperCase() == nameCountry;
        });

        if (CountryItem != null && CountryItem.Id != null) {
          this.$store
            .dispatch("ListState", { idCountry: CountryItem.Id })
            .then(response => {
              this.states = response;
            })
            .catch(error => this.$makeToast(undefined, "danger", "Erro ao obter lista de estados", error));
        }
      }
    },
    ListRefusedReason() {
      this.$store
        .dispatch("ListRefusedReason")
        .then(response => {
          this.refusedReasons = response || [];
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao carregar os motivos de recusa", error);
        });
    },
    RefusedReasonRetryHint(id) {
      const reason = this.refusedReasons.find(r => String(r.Id) === String(id));
      if (!reason) return "";
      // RetryPolicy: 0 = bloqueado, 1 = imediato, 2 = após RetryDays dias (dbo.RefusedReason)
      if (reason.RetryPolicy === 0) return "O cliente não poderá refazer o cadastro pelo site com este CNPJ.";
      if (reason.RetryPolicy === 1) return "O cliente poderá refazer o cadastro pelo site imediatamente.";
      return `O cliente poderá refazer o cadastro pelo site após ${reason.RetryDays} dias.`;
    },
    ListStatus() {
      this.$store
        .dispatch("ListMerchantPreviewStatus")
        .then(response => {
          this.listStatus = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro carregar a lista de situações", error);
        });
    },
    SearchByZipCode() {
      if (this.isView == false) {
        let zipCodeNumber = this.infoMerchantPreview.Address.ZipCode.replace(/\D+/gm, "");

        if (zipCodeNumber.length != 8) {
          this.$makeToast("O CEP digitado não é válido. " + zipCodeNumber, "danger", "CEP inválido");
          return;
        }

        this.$store
          .dispatch("ListCep", { zipCode: zipCodeNumber })
          .then((response) => {
            if (response.erro) {
              this.$makeToast("Verifique o número digitado e tente novamente.", "warning", "CEP não encontrado");
              return;
            }
            this.isSearchZipCode = true;

            this.infoMerchantPreview.Address.ZipCode = response.cep;
            this.infoMerchantPreview.Address.Street = response.logradouro;
            this.infoMerchantPreview.Address.District = response.bairro;

            this.infoMerchantPreview.Address.Country.Name = "BRASIL";
            this.infoMerchantPreview.Address.State.Initials = response.uf;
            this.infoMerchantPreview.Address.City.Name = response.localidade;
          })
          .catch((error) => {
            this.$makeToast("Não foi possível buscar o endereço.", "danger", "Busca de endereço");
          });
      }
    },
    //#endregion Non-Specific Lists
    
    //#region Default Values
    DefaultFilter() {
      return {
        Id: null,
        Name: null,
        Identity: null,
        CodeMerchantPreviewStatus: "3",
        BackgroundCheckList: [
          // { Id: 1, Status: "Aprovado" },  // Primeiro valor padrão
          // { Id: 2, Status: "Reprovado" }  // Segundo valor padrão
        ],
        InitialDate: null,
        FinalDate: null,
        ExcludeBackgroundCheck: false
      };
    },
    DefaultInfoMerchantPreview() {
      return {
        Name: null,
        Identity: null,
        IsMEI: false,
        IsBlocked: false,
        Description: "",
        DescriptionUnblocked: "",
        IdentityMerchantRoot: null, 
        IdMerchantRoot: null, 
        NameMerchantRoot: null, 
        BlockList: {
          Name: null,
          Identity: null,
          Email : null     
        },
        BillingType: {
          Code: null
        },
        Partner: {
          Id: 0
        },
        TypeReceipt: {
          Id: 0
        },
        AdditionalInformation: {
          GrossBillingAmount: 0,
          IsApi: false,
          IsInterface: false,
          IsMarketplace: false,
          IsOperation: false,
          IsOtherSoftware: false
        },
        Address: {
          Complement: "",
          District: null,
          Number: "",
          Street: "",
          ZipCode: "",
          City: {
            Name: null
          },
          State: {
            Initials: null
          },
          Country: {
            Name: null
          }
        },
        ProviderPrimary: {
          Id: 0,
          Code: null,
          Name: null
        },
        UserInternal: undefined,
        RefuseReason: null,
        IsAuthorizedAPI: false
      };
      
    },
    BuscarClassSituacao(situacao) {

      let variation = "";
      if (situacao.Id == 1) {
        variation = "badge badge-success";
      } else if (situacao.Id == 2)  {
        variation = "badge badge-danger";
      } else if (situacao.Id == 3)  {
        variation = "badge badge-info";
      }
      return variation;
   }
    //#endregion Default Values
  },
  beforeMount() {
    this.UserInternal = this.$getUserInternal();
  },
  mounted() {
    this.ListStatus();
    this.ListRefusedReason();
    this.ListCountry();
    this.ListPartner();
    this.ListMerchantPreview();
  },
};


// WEBPACK FOOTER //
// ./src/components/pages/MerchantPreview/MerchantPreview.js